import FormAccessory from "./Form/FormAccessory"

import api from '../../utils/api'

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function NewAccessory({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const navigate = useNavigate()


    async function registerAccessory(obj) {

        let msgType = 'success'


        const formData = new FormData()
        await Object.keys(obj).forEach((key) => formData.append(key, obj[key]))


        const data = await api.post(`/accessory/new`, formData, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }


    }

    return (
        <FormAccessory handleSubmit={registerAccessory} title="Cadastrar Acessório" btnText="Cadastrar" btCancelAction={btCancelAction} />
    )
}

export default NewAccessory